import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "addSeries-warp"
};
const _hoisted_2 = {
  class: "cms-card-block"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import { debounce, getItemByProp, removePropertyOfNull } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { usePageConfig } from '@/utils/useComponentConfig';
import { RELEASE_COLOR_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { inject, onMounted } from 'vue';
import { elMessage } from '@/utils';
import { getUserByCidApi } from '@/api/authority';
import { useCommon } from '@/store/useCommon';
import { getCurrentTime } from '@/utils/timeFormat';
import { getProgramSetListApi, addVodToCategoryApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddSeries',
  props: {
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const CODING_STATUS = {
      0: 'H.264',
      1: 'H.265'
    };
    const tableRef = ref(null);
    const headerConfig = ref({
      title: '添加系列',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '关键字筛选',
        prop: 'keyword',
        widgetType: 'input'
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('已上线'),
          value: 'online'
        }, {
          label: t('已下线'),
          value: 'offline'
        }, {
          label: t('未上线'),
          value: 'not_online'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getData();
        }
      }, {
        label: '操作用户',
        prop: 'operatorId',
        widgetType: 'Select',
        labelKey: 'name',
        filterable: true,
        valueKey: 'id',
        list: [],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getData();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          tableConfig.paginationConfig.page = 1;
          getData();
        }, 200)
      }, {
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        list: [],
        filterable: true,
        // clearable: true,
        controller: () => {
          return false; // return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getData();
        },
        props: {
          label: 'name',
          children: 'children',
          value: 'id'
        }
      }],
      formData: {
        keyword: '',
        releaseStatus: '',
        // language: '',
        time: '',
        operatorId: '',
        cpspId: null
      },
      search: () => {
        tableConfig.paginationConfig.page = 1;
        getData();
      },
      reset: () => {
        sortParams.sortType = '';
        sortParams.sortField = '';
        tableRef.value.commonTableRef.clearSort();
        tableConfig.paginationConfig.page = 1;
        searchConfig.formData.cpspId = sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || 0;
        getData();
      }
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      // isShowHeader: false,
      config: {
        loading: false
      },
      //   height: '500px',
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '系列片名称',
        prop: 'name',
        sortable: 'custom'
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        cellSlot: true,
        sortable: 'custom'
      }, {
        label: '节目数',
        prop: 'count',
        sortable: 'custom'
      }, {
        label: '编码协议',
        prop: 'videoCode',
        sortable: 'custom' // formatter: (value: any) => {
        //     if (value) {
        //         let arr = value.split(',')
        //         const res = arr.map(item => CODING_STATUS[Number(item)])
        //         return res.join()
        //     }
        // }

      }, {
        label: '操作用户',
        prop: 'operatorName',
        sortable: 'custom'
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }],
      'row-key': row => {
        return row.id;
      }
    });
    const productOperationsCid = ref(sessionStorage.getItem('productOperationsCid'));
    const rowItemInfo = inject('rowItemInfo');
    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 表格复选框回显数据id


    const vodInfo = ref({
      ids: [],
      objIds: []
    }); // 获取列表数据

    const getData = async () => {
      !tableConfig.config.loading ? tableConfig.config.loading = true : '';

      try {
        let params = {
          cid: productOperationsCid.value,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...searchConfig.formData,
          //categoryId: rowItemInfo.id,
          ...sortParams
        };

        if (params.time && params.time.length) {
          params.startTime = params.time[0];
          params.endTime = params.time[1];
          delete params.time;
        }

        const res = await getProgramSetListApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.data = res.data;
          tableConfig.paginationConfig.total = res.total;
        } // vodInfo.value.objIds.forEach(vodInfoItem => {
        //     tableRef.value.commonTableRef.toggleRowSelection(vodInfoItem, true)
        // })

      } catch (error) {}

      tableConfig.config.loading = false;
    }; // 底部取消按钮点击事件


    const onCancel = () => {
      props.returnBackFn();
    }; // 底部确认按钮点击事件


    const onConfirm = debounce(async () => {
      if (selectTableConfig.selectData.length === 0) {
        return elMessage('warning', '请先勾选需要添加的影片');
      } else {
        try {
          let setIds = selectTableConfig.selectData.filter(item => vodInfo.value.ids.indexOf(item.id) == -1);
          setIds = setIds.map(item => item.id);
          let params = {
            categoryId: rowItemInfo.id,
            categoryProgramIds: setIds
          }; // console.log(params);

          if (setIds.length > 0) {
            const res = await addVodToCategoryApi(params);

            if (res.code == '0') {
              elMessage('success', '新增成功');
              props.returnBackFn();
            }
          } else {
            elMessage('success', '新增成功');
            props.returnBackFn();
          }
        } catch (error) {}
      }
    }, 200);
    const sortParams = reactive({
      sortType: '',
      sortField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      // console.log(params);
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getData();
      } else {
        sortParams.sortType = '';
        sortParams.sortField = '';
        getData();
      }
    }, 200); // 获取操作用户

    const getUserByCid = async params => {
      let item = getItemByProp(searchConfig.formList, 'operatorId');

      try {
        const res = await getUserByCidApi(params);

        if (res.code == '0') {
          // item.list = [{ agentName: t('全部'), id: '' }, ...res.data]
          item.list = [{
            name: t('全部'),
            id: ''
          }, ...res.data.sort(function (a, b) {
            return a.name.trim().localeCompare(b.name.trim());
          })];
        }
      } catch (error) {}
    };

    onMounted(async () => {
      let cpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || 0 : useCommon().userData.cpspid || 0;
      searchConfig.formData.cpspId = cpspid;
      tableConfig.config.loading = true;

      if (useCommon().userData.permissionKey.indexOf('DC_OU') > -1) {
        getUserByCid({
          cid: productOperationsCid.value
        });
      }

      getData();
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_ButtomBtns = _resolveComponent("ButtomBtns");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 50,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.search,
        onReset: searchConfig.reset
      }, null, 8, ["size", "form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_common_table, {
        extraHeight: 73,
        dynamicTableMaxHeight: "",
        "show-title": false,
        "option-column-list": tableConfig.columnList,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.config,
        render: getData,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'releaseStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle([{
              "white-space": "nowrap",
              "overflow": "hidden",
              "text-overflow": "ellipsis"
            }, 'color:' + _unref(RELEASE_COLOR_NEW)[scope.row.releaseStatus]])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options", "onSortChange"]), _createVNode(_component_ButtomBtns, {
        style: {
          "margin-top": "50px"
        },
        onOnCancel: onCancel,
        onOnConfirm: _unref(onConfirm),
        confirmDisabled: !selectTableConfig.selectData.length
      }, null, 8, ["onOnConfirm", "confirmDisabled"])])]);
    };
  }

});